import { render, staticRenderFns } from "./PaxFormCAAAgent.vue?vue&type=template&id=7c1af773&"
import script from "./PaxFormCAAAgent.vue?vue&type=script&lang=ts&"
export * from "./PaxFormCAAAgent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports